import PageContainer from '@/common/components/PageContainer'
import RankExperienceSetting from '@/modules/manage-rank/components/RankExperienceSetting'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import Heading from '@/common/shared/heading'

function RankSettingsPage() {
	return (
		<PageContainer>
			<div className="space-y-6">
				<Heading
					title="ตั้งค่าคะแนนประสบการณ์"
					description="จัดการการตั้งค่าคะแนนประสบการณ์สำหรับระบบยศ"
				/>
				<RankExperienceSetting />
			</div>
		</PageContainer>
	)
}

const GuardedRankSettingsPage = withUserPermission(RankSettingsPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_RANK],
})

export default GuardedRankSettingsPage
